/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TipoPraticaRegolaPunteggioFasciaPatchForm { 
    version: number;
    soglia_max: number;
    punti: number;
    ordine: number;
}

